
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/toplists",
      function () {
        return require("private-next-pages/destinations/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/toplists"])
      });
    }
  